"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calcStickyPositions = calcStickyPositions;
exports.getRows = getRows;
var _classes = require("./classes");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var resolveTableCells = function resolveTableCells(rows) {
  var rowSpannedCellCounts = [];
  var rowSpannedCells = [];
  return rows.map(function (row) {
    var cellNode;
    var nodeIndex = 0;
    var nodes = [];
    var cells = row.cells,
      id = row.id;
    for (var i = 0; i <= cells.length; i++) {
      nodeIndex = nodes.length;
      while (rowSpannedCellCounts[nodeIndex]) {
        rowSpannedCellCounts[nodeIndex]--;
        nodes.push([undefined, rowSpannedCells[nodeIndex]]);
        nodeIndex = nodes.length;
      }
      if (cellNode = cells[i]) {
        var rowSpanAttr = cellNode.getAttribute('rowspan');
        var colSpanAttr = cellNode.getAttribute('colspan');
        var rowSpan = rowSpanAttr ? +rowSpanAttr - 1 : 0;
        var colSpan = colSpanAttr ? +colSpanAttr : 1;
        nodes.push([cellNode]);
        if (rowSpan) {
          rowSpannedCells[nodeIndex] = cellNode;
          rowSpannedCellCounts[nodeIndex] = rowSpan;
        }
        for (var j = 1; j < colSpan; j++) {
          rowSpannedCellCounts[nodeIndex + j] = rowSpan;
          nodes.push([undefined, undefined, cellNode]);
        }
      }
    }
    return {
      id: id,
      cells: nodes
    };
  });
};
function calcStickyPositions(rows, _ref) {
  var _ref$leftStickyColumn = _ref.leftStickyColumnCount,
    leftStickyColumnCount = _ref$leftStickyColumn === void 0 ? 0 : _ref$leftStickyColumn,
    _ref$rightStickyColum = _ref.rightStickyColumnCount,
    rightStickyColumnCount = _ref$rightStickyColum === void 0 ? 0 : _ref$rightStickyColum,
    topStickyRowsCount = _ref.topStickyRowsCount,
    bottomStickyRowCount = _ref.bottomStickyRowCount;
  var resolvedRows = resolveTableCells(rows);
  var stickyInsets = {};
  [['header', topStickyRowsCount], ['footer', bottomStickyRowCount]].forEach(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      stickyKey = _ref3[0],
      count = _ref3[1];
    var insets = [];
    var index = 0;
    var netInsetArr = [];
    var _loop = function _loop() {
      switch (stickyKey) {
        case 'header':
          index = s;
          break;
        case 'footer':
          index = resolvedRows.length - 1 - s;
          break;
      }
      var row = resolvedRows[index];
      if (row) {
        var cells = row.cells,
          id = row.id;
        var rowInsets = [];
        cells.forEach(function (_ref4, j) {
          var _ref6;
          var _ref5 = _slicedToArray(_ref4, 3),
            cellNode = _ref5[0],
            _rowSpannedCell = _ref5[1],
            colSpannedCell = _ref5[2];
          if (netInsetArr[j] === undefined) {
            netInsetArr[j] = 0;
          }
          if (cellNode) {
            rowInsets.push(netInsetArr[j]);
          }
          netInsetArr[j] += ((_ref6 = cellNode || colSpannedCell) === null || _ref6 === void 0 ? void 0 : _ref6.getBoundingClientRect().height) || 0;
        });
        insets.push({
          id: id,
          insets: rowInsets
        });
      }
    };
    for (var s = 0; s < count; s++) {
      _loop();
    }
    stickyInsets[stickyKey] = insets;
  });
  var rowsStickyInsets = resolvedRows.map(function (_ref7) {
    var id = _ref7.id,
      cells = _ref7.cells;
    var rowStickyInsets = {
      id: id
    };
    [['leftColumn', leftStickyColumnCount], ['rightColumn', rightStickyColumnCount]].forEach(function (_ref8) {
      var _ref9 = _slicedToArray(_ref8, 2),
        stickyKey = _ref9[0],
        count = _ref9[1];
      var insets = [];
      var index = 0;
      var netInset = 0;
      for (var s = 0; s < count; s++) {
        var _ref0;
        switch (stickyKey) {
          case 'leftColumn':
            index = s;
            break;
          case 'rightColumn':
            index = cells.length - 1 - s;
            break;
        }
        var _cells$index = _slicedToArray(cells[index], 2),
          cellNode = _cells$index[0],
          rowSpannedCell = _cells$index[1];
        if (cellNode) {
          insets.push(netInset);
        }
        netInset += ((_ref0 = cellNode || rowSpannedCell) === null || _ref0 === void 0 ? void 0 : _ref0.getBoundingClientRect().width) || 0;
      }
      rowStickyInsets[stickyKey] = insets;
    });
    return rowStickyInsets;
  });
  stickyInsets.rows = rowsStickyInsets;
  return stickyInsets;
}
function getRows(parentNode) {
  if (!parentNode) {
    return [];
  }
  return Array.from(parentNode.querySelectorAll(".".concat(_classes.STICKY_TABLE_ROW))).map(function (rowNode) {
    var id = rowNode.id;
    return {
      cells: Array.from(rowNode.querySelectorAll(".".concat(_classes.STICKY_TABLE_CELL))),
      id: id
    };
  });
}